export default __webpack_public_path__ + "static/media/Qaumah.9c1b4862.mp3";